import { BsHouseFill } from 'react-icons/bs';

import { Box } from '@qwealth/qcore';

import { BASE_DATE_FORMAT, formatDate } from './dateTimeHelper';
import {
  TRADE_REQUEST_FILTERS_KEY,
  TradeRequestFilters,
  TradeRequestItem,
  TradeRequestStatus,
} from 'data/models/TradeRequest';
import { caseInsensitiveFuzzySearch } from 'utils/search';
import NavigationLink from 'components/common/NavigationLink';
import InfoTag from 'components/common/SectionHeader/InfoTag';
import { ColumnDescription } from 'react-bootstrap-table-next';

export const initialFilters: TradeRequestFilters = {
  status: null,
  partnerName: null,
  assignedTo: null,
  tag: null,
  dueDateStart: undefined,
  dueDateEnd: undefined,
};

export const getSavedFilters = (): TradeRequestFilters => {
  const saved = localStorage.getItem(TRADE_REQUEST_FILTERS_KEY);
  if (saved) {
    return JSON.parse(saved);
  }
  return initialFilters;
};

export const saveFiltersInLocalStorage = (filters: TradeRequestFilters): void => {
  localStorage.setItem(TRADE_REQUEST_FILTERS_KEY, JSON.stringify(filters));
};

export const search = (item: TradeRequestItem, query: string): boolean =>
  caseInsensitiveFuzzySearch(query, [
    item.householdQID,
    item.householdName,
    item.partnerName,
    item.iaCode,
    item.assignedTo,
    item.title,
  ]);

export const filteredTradeRequests = (items: TradeRequestItem[], query: string): TradeRequestItem[] =>
  items.filter(item => search(item, query));

const householdFormatter = (cell: string, row: TradeRequestItem) => (
  <NavigationLink
    content={{ label: cell, link: `/household?household=${row.householdQID}` }}
    icon={<BsHouseFill size="14px" />}
    fontSize="small"
  />
);

const statusFormatter = (cell: TradeRequestStatus) => <InfoTag tagTitle={cell} fontSize="small" />;

const tagsFormatter = (cell: string[]) => (
  <Box display="flex" flexDirection="row" gap="small" flexWrap="wrap">
    {cell.map(tag => (
      <InfoTag key={tag} tagTitle="Task Tag" taskTagTitle={tag} fontSize="small" />
    ))}
  </Box>
);

const dueDateFormatter = (cell: string | null) => {
  if (!cell) return null;
  return formatDate(cell, BASE_DATE_FORMAT);
};

export const createColumns = (): ColumnDescription[] => [
  {
    text: 'Household QID',
    dataField: 'householdQID',
    hidden: true,
    editable: false,
  },
  {
    text: 'Household',
    dataField: 'householdName',
    sort: true,
    editable: false,
    formatter: householdFormatter,
  },
  {
    text: 'Request Title',
    dataField: 'title',
    sort: true,
    editable: false,
  },
  {
    text: 'Partner',
    dataField: 'partnerName',
    sort: true,
    editable: false,
  },
  {
    text: 'IA Code',
    dataField: 'iaCode',
    sort: true,
    editable: false,
  },
  {
    text: 'Due Date',
    dataField: 'dueDate',
    sort: true,
    editable: false,
    formatter: dueDateFormatter,
  },
  {
    text: 'Status',
    dataField: 'status',
    sort: true,
    editable: false,
    formatter: statusFormatter,
  },
  {
    text: 'Tags',
    dataField: 'tags',
    sort: false,
    editable: false,
    formatter: tagsFormatter,
  },
  {
    text: 'Assignee',
    dataField: 'assignedTo',
    sort: true,
    editable: false,
  },
];
